// Halve It: a fixed sequence of rounds, each independently scoreable for any
// player in any order (this is a "cell-entry" game - clicking a grid cell
// opens a widget scoped to that one round, and submits a single value into
// it). A round score of exactly 0 means "missed" and halves the player's
// running total (rounded up) instead of adding to it.

export const ROUNDS = [
    { name: "14", description: "Hit 14" },
    { name: "Doubles", description: "Any double" },
    { name: "15", description: "Hit 15" },
    { name: "Triples", description: "Any triple" },
    { name: "16", description: "Hit 16" },
    { name: "3 Adjacent", description: "3 adjacent" },
    { name: "17", description: "Hit 17" },
    { name: "3 Colors", description: "3 colors" },
    { name: "18", description: "Hit 18" },
    { name: "Bulls", description: "Bull/Bullseye" },
    { name: "19", description: "Hit 19" },
    { name: "Score 41", description: "Exactly 41" },
    { name: "20", description: "Hit 20" }
];

// Which input widget a round's keypad should show. Numbers 14-20 zoom the
// dartboard to that single wedge; Bulls zooms to the bull; Score 41 is a
// binary hit/miss button; everything else (doubles/triples/adjacent/colors)
// is a plain numeric pad since there's no single dartboard region to tap for
// those.
export function inputWidgetFor(round) {
    const isNumberRound = round.name.trim() !== '' && !isNaN(Number(round.name));
    if (isNumberRound) {
        return { type: 'dartboard-number', target: Number(round.name), maxMultiplier: 3 };
    }
    if (round.name === 'Bulls') {
        return { type: 'dartboard-bull', target: 25, maxMultiplier: 2 };
    }
    if (round.name === 'Score 41') {
        return { type: 'fortyone' };
    }
    return { type: 'numeric' };
}

// roundScores here is one player's map of roundIndex -> entered score. Totals
// are computed in round order regardless of which order the rounds were
// filled in, since a halve (score === 0) only makes sense applied against
// whatever total had accumulated up to that round.
export function computeTotal(roundScores) {
    let total = 0;
    for (let i = 0; i < ROUNDS.length; i++) {
        const score = roundScores[i];
        if (score === undefined) continue;
        total = score === 0 ? Math.ceil(total / 2) : total + score;
    }
    return total;
}

// roundScoresByPlayer: { [player]: { [roundIndex]: number } }
export function isComplete(players, roundScoresByPlayer) {
    return players.every(player =>
        ROUNDS.every((_, i) => roundScoresByPlayer[player][i] !== undefined)
    );
}

// Highest total wins.
export function rankPlayers(players, scores) {
    return players.slice().sort((a, b) => scores[b] - scores[a]);
}

export default {
    id: 'halveit',
    name: 'Halve It',
    description: '13 fixed rounds, each its own challenge - hit numbers, doubles, triples, colors and more. Score in any round in any order, but miss one entirely and your running total gets halved instead.',
    minPlayers: 1,
    display: 'rounds-grid',
    input: 'cell-entry',
    supportsCpuPlayers: true,
    rounds: ROUNDS,
    inputWidgetFor,
    computeTotal,
    isComplete,
    rankPlayers
};
